import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 3}, 1fr);
  gap: ${props => props.gap || '15px'};
  width: ${props => props.width || '100%'};
  margin: 0 auto;
  
  @media(max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media(max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ImageBox = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: ${props => props.radius || '12px'};
  overflow: hidden;
  position: relative;
  border: 1px solid var(--glass-border);

  img {
    width: 100%;
    height: 100%;
    object-fit: ${props => props.fit || 'cover'};
    transition: transform 0.4s;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 50%);
    opacity: 0;
    transition: opacity 0.4s;
  }

  &:hover {
    img { transform: scale(1.1); }
    &::after { opacity: 1; }
  }
`;

const ImageGalleryWidget = ({ node }) => {
  const images = node.content?.images || [
    'https://via.placeholder.com/400x400/1e293b/00A9E0?text=IMG+1',
    'https://via.placeholder.com/400x400/1e293b/00A9E0?text=IMG+2',
    'https://via.placeholder.com/400x400/1e293b/00A9E0?text=IMG+3',
    'https://via.placeholder.com/400x400/1e293b/00A9E0?text=IMG+4',
    'https://via.placeholder.com/400x400/1e293b/00A9E0?text=IMG+5',
    'https://via.placeholder.com/400x400/1e293b/00A9E0?text=IMG+6'
  ];

  return (
    <Wrapper columns={node.style?.desktop?.columns} gap={node.style?.desktop?.gap} width={node.style?.desktop?.width}>
      {images.map((src, i) => (
        <ImageBox key={i} radius={node.style?.desktop?.radius} fit={node.style?.desktop?.fit}>
          <img src={src} alt={`Gallery ${i+1}`} />
        </ImageBox>
      ))}
    </Wrapper>
  );
};

registry.register('image_gallery', {
  label: 'Bilder Galerie',
  icon: '🖼️',
  category: 'media',
  defaultContent: {},
  defaultStyle: { desktop: { columns: 3, gap: '15px', radius: '12px', fit: 'cover', width: '100%' } },
  render: ImageGalleryWidget,
  inspectorControls: [
    { tab: 'style', groups: [{ title: 'Grid', fields: [{name:'style.desktop.columns', label:'Spalten', type:'select', options:[{label:'2', value:'2'},{label:'3', value:'3'},{label:'4', value:'4'}]}, {name:'style.desktop.gap', label:'Abstand', type:'text'}, {name:'style.desktop.radius', label:'Border Radius', type:'text'}, {name:'style.desktop.fit', label:'Object Fit', type:'select', options:[{label:'Cover', value:'cover'},{label:'Contain', value:'contain'}]}] }] }
  ]
});
